import React, { useRef } from 'react'
import { Camera, ImagePlus } from 'lucide-react'
import {
  Card,
  ImageBox,
  ImageEmpty,
  ImageLabel,
  ImageOverlay,
  ImagePreview,
  ImagesRow,
} from './styles'
import { GeneralFile } from './types'

type SlotKey = 'front' | 'side' | 'back'

interface SlotProps {
  label: string
  file: GeneralFile | null
  onPick: (file: File) => void
  disabled?: boolean
}

const ImageSlot: React.FC<SlotProps> = ({ label, file, onPick, disabled }) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const handleClick = () => {
    if (disabled) return
    inputRef.current?.click()
  }
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0]
    if (f) onPick(f)
    e.target.value = ''
  }

  return (
    <ImageBox $hasImage={!!file} $disabled={!!disabled} onClick={handleClick}>
      {file ? (
        <>
          <ImagePreview src={file.fileUrl} alt={label} />
          {!disabled && (
            <ImageOverlay className='overlay'>
              <ImagePlus size={20} />
              <span style={{ fontSize: 12, fontWeight: 600 }}>Trocar</span>
            </ImageOverlay>
          )}
        </>
      ) : (
        <ImageEmpty>
          <Camera size={28} />
          <span>{disabled ? '—' : 'Adicionar foto'}</span>
        </ImageEmpty>
      )}
      <ImageLabel>{label}</ImageLabel>
      <input
        ref={inputRef}
        type='file'
        accept='image/*'
        style={{ display: 'none' }}
        onChange={handleChange}
        disabled={disabled}
      />
    </ImageBox>
  )
}

interface Props {
  front: GeneralFile | null
  side: GeneralFile | null
  back: GeneralFile | null
  onUpload: (slot: SlotKey, file: File) => void
  disabled?: boolean
}

const ImagesSection: React.FC<Props> = ({ front, side, back, onUpload, disabled }) => {
  return (
    <Card>
      <ImagesRow>
        <ImageSlot
          label='Frente'
          file={front}
          onPick={(f) => onUpload('front', f)}
          disabled={disabled}
        />
        <ImageSlot
          label='Lateral'
          file={side}
          onPick={(f) => onUpload('side', f)}
          disabled={disabled}
        />
        <ImageSlot
          label='Costas'
          file={back}
          onPick={(f) => onUpload('back', f)}
          disabled={disabled}
        />
      </ImagesRow>
    </Card>
  )
}

export default ImagesSection
